import { CmsObjectWithDefault } from '@components/Cms/types';

export type WalletOtpFormCmsKey =
    | 'WalletOtpTitle'
    | 'WalletOtpCaption'
    | 'DidntReceive'
    | 'ResendCode'
    | 'WalletWithdrawTitle'
    | 'WalletPaymentTitle'
    | 'WalletStatementTitle'
    | 'UsePasskeyLabel';

export const WalletOtpFormCmsWithDefault: CmsObjectWithDefault<WalletOtpFormCmsKey> = {
    WalletOtpTitle: {
        cmsId: 358278,
        defaultTranslation: "We've sent you an OTP",
    },
    WalletOtpCaption: {
        cmsId: 358279,
        defaultTranslation: 'Enter the 6-digit code sent to {0}',
    },
    DidntReceive: {
        cmsId: 358280,
        defaultTranslation: 'Didn’t receive it?',
    },
    ResendCode: {
        cmsId: 358281,
        defaultTranslation: 'Resend code.',
    },
    WalletWithdrawTitle: {
        cmsId: 368053,
        defaultTranslation: 'Authorize withdrawal of {0} {1}',
    },
    WalletPaymentTitle: {
        cmsId: 368054,
        defaultTranslation: 'Authorize payment of {0} {1}',
    },
    WalletStatementTitle: {
        cmsId: 398437,
        defaultTranslation: 'Authorize the statement request',
    },
    UsePasskeyLabel: {
        cmsId: 541408,
        defaultTranslation: 'Use Passkey',
    },
};
